import { Directive, OnInit, Input, HostListener, Renderer2, ElementRef, HostBinding } from '@angular/core';
import { PermissionsService } from 'app/modules-services/permissions.service';
import { NotifyUserService } from '../notify-user.service';

@Directive({
    selector: '[hasPermissions]',

})
export class DisableButtonsOnRole implements OnInit {
    @HostBinding('style.pointer-events') get pEvents(): string {
        if (this.permissionsService.doCheckAuthorization(this.hasPermissions) === false) {
            return 'none';
        }
        return 'auto';
    }
    @Input('hasPermissions') hasPermissions: string;
    @HostListener('click', ['$event, $event.target'])
    onClick(e, targetElement) {
        const element = e.srcElement.parentElement;

        console.warn('e', e);
        console.warn('element', element);
        console.warn('permissionsService', this.permissionsService.doCheckAuthorization(this.hasPermissions));

        if (this.permissionsService.doCheckAuthorization(this.hasPermissions) === false) {
            e.stopPropagation();
            e.preventDefault();
            e.cancelBuble = true;
            e.stopImmediatePropagation();
            this.notifyUser.showWarn('Non sei autorizzato!!');
        }
    }



    constructor(private element: ElementRef,
        private notifyUser: NotifyUserService, private renderer: Renderer2,
        private permissionsService: PermissionsService) {
    }

    ngOnInit(): void {

    }


    ngOnDestroy(): void {
    }
}
